import { WebsiteData } from "../interface/website";
import { errorHandler } from "./errorHandler";
import { apiRequest } from "./apiRequest";

export const updateWebsites = async (
  id: number,
  args: Partial<WebsiteData>
): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "patch",
      `/websites/${id}`,
      { data: args }
    );
    return data.message;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to update user");
  }
};
